import '@/styles/globals.css';
import Head from 'next/head';
import { useState, useEffect } from 'react'; // Importar useState y useEffect
import PropTypes from 'prop-types';
import Header from './containers/Header.server';  // Importa el Header
import Footer from './containers/Footer.server';

function MyApp({ Component, pageProps }) {
  const [theme, setTheme] = useState('dark');

  useEffect(() => {
    // Verifica el tema guardado en localStorage
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      setTheme(savedTheme);
      document.documentElement.classList.add(savedTheme); // Aplica la clase dark o light
    } else {
      // Si no hay tema guardado, aplica el valor predeterminado
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      const initialTheme = prefersDark ? 'dark' : 'light';
      setTheme(initialTheme);
      document.documentElement.classList.add(initialTheme); // Aplica el tema según la preferencia del sistema
    }
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme); // Guarda el tema en localStorage
    document.documentElement.classList.toggle('dark', newTheme === 'dark'); // Aplica el tema
  };

  return (
    <>
      <Head>
        <title>Dravvt - Merging Art and Technology</title>
        <meta name="description" content="Explore the intersection of art and technology through insightful articles and projects." />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      {/* Pasamos el estado y la función toggleTheme al Header */}
      <Header theme={theme} toggleTheme={toggleTheme} />

      {/* El contenido de la página específica */}
      <main>
        <Component {...pageProps} />
      </main>

      {/* El Footer se renderiza globalmente */}
      <Footer />
    </>
  );
}

MyApp.propTypes = {
  Component: PropTypes.elementType.isRequired,
  pageProps: PropTypes.object.isRequired,
};

export default MyApp;

